
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/komodo-defi-framework/api/legacy/trade_preimage",
      function () {
        return require("private-next-pages/docs/komodo-defi-framework/api/legacy/trade_preimage/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/komodo-defi-framework/api/legacy/trade_preimage"])
      });
    }
  